import React, { useEffect } from "react";
import ReactGA from 'react-ga4';
import './adminsInfo.scss';

import AdminsTable from "./adminsTable";
import AdminsList from "./adminsList";

const AdminsInfo = () => {

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: `/admins` })
    }, [])

    return (
        <>
            <AdminsTable />
            <div className='adminsList boxShadow'>
                <AdminsList />
            </div>
        </>

    )
}

export default AdminsInfo;